import React, {useContext, useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import {maxMediaQueries} from '../../utils/styling';
import {GlobalContext} from '../../context/GlobalContext';
import {CloseIcon} from '../../atoms/Icons/closeIcon';

const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 24px;
  background: rgba(150, 161, 169, 0.51);
  z-index: 1011;
  
  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    
     ${maxMediaQueries.sm`
        display: none;
     `}
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  animation: fadeInFromNone 1500ms ease-out;
  
@keyframes fadeInFromNone {
    0% {
        display: none;
        opacity: 0;
    }

    80% {
        display: flex;
        opacity: 0;
    }

    100% {
        display: flex;
        opacity: 1;
    }
}
  
  
`;

const HubspotCalendar = () => {
  const modalRef = useRef(null);
  const {closeContactForm: close} = useContext(GlobalContext);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (!scriptLoaded) {
      loadHubspotScript(() => setScriptLoaded(true));
      disableBodyScroll();
    }

    return () => {
      destroyHubspotScript();
      enableBodyScroll();
    };
  });

  const loadHubspotScript = (callback) => {
    const existingScript = document.getElementById('hubspotScript');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      script.id = 'hubspotScript';
      document.body.appendChild(script);

      script.onload = () => {
        if (callback) callback();
      };
    }

    if (existingScript && callback) callback();
  };

  const destroyHubspotScript = (callback) => {
    const existingScript = document.getElementById('hubspotScript');

    if (existingScript) {
      document.body.removeChild(existingScript);
      if (callback) {
        callback();
      }
    }
  };

  return ReactDOM.createPortal(
      <ModalWrapper onClick={close}>
        <CloseIcon/>
        <ModalContent ref={modalRef} onClick={e => {
          e.stopPropagation();
        }}>
          <div className="meetings-iframe-container"
               data-src="https://meetings.hubspot.com/jeremy-brosseau/demo-request?embed=true"/>
        </ModalContent>
      </ModalWrapper>,
      document.querySelector('body')
  );

};

export default HubspotCalendar;
